import { SearchAndFindStriker } from "icons";
import styles from "./styles.module.scss";

export const SearchAndFineOne = () => {
  return (
    <div className={styles.searchTextContainer}>
      <div>
        <div style={{ textAlign: "center" }}>
          <SearchAndFindStriker />
        </div>

        <p className={styles.text}>
          You haven’t connected with any strikers yet. Use the search to find
          and add one!
        </p>
      </div>
    </div>
  );
};
